// extracted by mini-css-extract-plugin
export default {"title":"beam-list-block_title__2ZAdX","description":"beam-list-block_description__rc1ki","list":"beam-list-block_list__Ew3yY"};